<ul [class]="classes">
  <ng-content></ng-content>
</ul>
